import style from '../index.module.scss';

const HtmlBlock = ({ topic, getBgColor }) =>
  topic?.homepage_message?.active &&
  topic?.homepage_message?.content && (
    <div
      className="flex soft-double--bottom"
      style={{
        backgroundColor: getBgColor(
          topic.home_config.section_html_block_top_body_background_color,
        ),
      }}
    >
      <div className="relative push-half--bottom soft-half-push flex-grow--1 width--100-percent">
        <div
          className={`ckeditor-content--reset ${style['homepage-container']}`}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: topic.homepage_message.content,
          }}
        />
      </div>
    </div>
  );

export default HtmlBlock;
